import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ConfigProvider, theme as antdTheme } from 'antd';
import zhCN from 'antd/locale/zh_CN';

import AdminLayout from './components/Layout/AdminLayout';
import SmartRedirect from './components/Layout/SmartRedirect';
import Dashboard from './pages/Dashboard/Dashboard';
import UserManagement from './pages/Users/UserManagement';
import LogManagement from './pages/Logs/LogManagement';
import ApiLogManagement from './pages/ApiLogs/ApiLogManagement';
import BillingRecords from './pages/BillingRecords';
import StatsPage from './pages/Stats/StatsPage';
import ApiKeyManagement from './pages/ApiKeys/ApiKeyManagement';
import Login from './pages/Login/Login';
import Register from './pages/Register/Register';
// 权限管理相关页面
import PermissionManagement from './pages/Permissions/PermissionManagement';
import RoleManagement from './pages/Roles/RoleManagement';
import UserRoleManagement from './pages/UserRoles/UserRoleManagement';
// 大模型管理页面
import ModelManagement from './pages/ModelManagement/ModelManagement';
// 用户偏好和API测试页面
import UsageInfo from './pages/UserPreferences/UserPreferences';
import ApiTest from './pages/ApiTest/ApiTest';
import SettingsPage from './pages/Settings/SettingsPage';
import RechargeManagement from './pages/Recharge/RechargeManagement';
import RechargeOrderManagement from './pages/RechargeOrders';
// 聊天功能页面
import ChatInterface from './pages/Chat';
// 测试组件已移除

// 权限上下文
import { PermissionProvider } from './context/PermissionContext';
import { useTheme } from './context/ThemeContext';

import LandingPage from './pages/LandingPage';

import 'antd/dist/reset.css';

// 创建一个内部组件来使用useTheme钩子
const AppContent: React.FC = () => {
  const { theme } = useTheme();
  return (
    <ConfigProvider
      locale={zhCN}
      theme={{
        algorithm: theme === 'dark' ? antdTheme.darkAlgorithm : antdTheme.defaultAlgorithm,
      }}
    >
      <PermissionProvider>
        <Router>
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/admin" element={<AdminLayout />}>
              <Route path="dashboard" element={<Dashboard />} />
              <Route path="users" element={<UserManagement />} />
              <Route path="apikeys" element={<ApiKeyManagement />} />
              <Route path="logs" element={<LogManagement />} />
              <Route path="api-logs" element={<ApiLogManagement />} />
              <Route path="billing-records" element={<BillingRecords />} />
              <Route path="logs/stats" element={<StatsPage />} />
              <Route path="stats" element={<StatsPage />} />
              {/* 权限管理相关路由 */}
              <Route path="permissions" element={<PermissionManagement />} />
              <Route path="roles" element={<RoleManagement />} />
              <Route path="user-roles" element={<UserRoleManagement />} />
              {/* 大模型管理路由 */}
              <Route path="models" element={<ModelManagement />} />
              <Route path="recharge" element={<RechargeManagement />} />
              <Route path="recharge-orders" element={<RechargeOrderManagement />} />
              {/* 用户偏好和API测试路由 */}
              <Route path="usage-info" element={<UsageInfo />} />
              <Route path="api-test" element={<ApiTest />} />
              {/* 聊天功能路由 */}
              <Route path="chat" element={<ChatInterface />} />
              <Route path="settings" element={<SettingsPage />} />
              {/* 测试路由已移除 */}
              <Route index element={<SmartRedirect />} />
            </Route>
          </Routes>
        </Router>
      </PermissionProvider>
    </ConfigProvider>
  );
};

const App: React.FC = () => {
  return <AppContent />;
};

export default App; 